import RankTwenty from '@assets/icons/rank-twenty.svg'
import { Icon } from './Icon'

export const RankTwentyIcon = Icon(RankTwenty)
